/* HALFTONE RUSH — theme scripts (vanilla, no dependencies) */
(function () {
  if (window.__hrInit) return;
  window.__hrInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveals ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('hr-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function splitWords(el) {
    if (el.dataset.hrSplit) return;
    el.dataset.hrSplit = '1';
    var nodes = Array.prototype.slice.call(el.childNodes);
    var i = 0;
    el.innerHTML = '';
    nodes.forEach(function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { el.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span'); w.className = 'hr-word';
          var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--w', i++);
          w.appendChild(s); el.appendChild(w);
        });
      } else if (n.nodeName === 'BR') {
        el.appendChild(n);
      } else {
        var w2 = document.createElement('span'); w2.className = 'hr-word';
        var s2 = document.createElement('span'); s2.style.setProperty('--w', i++);
        s2.appendChild(n); w2.appendChild(s2); el.appendChild(w2);
      }
    });
  }

  function initReveals(root) {
    (root || document).querySelectorAll('.hr-words').forEach(splitWords);
    (root || document).querySelectorAll('.hr-reveal, .hr-words, .hr-panel-in, .hr-rule, [data-hr-reveal]').forEach(function (el) {
      if (el.dataset.hrObs) return; el.dataset.hrObs = '1';
      if (!io || reduce) { el.classList.add('hr-visible'); return; }
      io.observe(el);
    });
  }

  /* ---------- marquee: fill to 2x width ---------- */
  function initTickers(root) {
    (root || document).querySelectorAll('[data-hr-ticker]').forEach(function (t) {
      if (t.dataset.hrInit) return; t.dataset.hrInit = '1';
      var track = t.querySelector('.hr-ticker__track'); if (!track) return;
      var guard = 0;
      while (track.scrollWidth < t.offsetWidth * 1.2 && guard++ < 8) {
        track.innerHTML += track.innerHTML;
      }
      var clone = track.cloneNode(true); clone.setAttribute('aria-hidden', 'true');
      t.appendChild(clone);
    });
  }

  /* ---------- header: sticky shadow + mobile menu ---------- */
  function initHeader() {
    var h = document.querySelector('[data-hr-header]');
    if (h && !h.dataset.hrInit) {
      h.dataset.hrInit = '1';
      var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    var menu = document.querySelector('[data-hr-menu]');
    if (menu && !menu.dataset.hrInit) {
      menu.dataset.hrInit = '1';
      var open = function () { menu.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
      var close = function () { menu.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
      document.querySelectorAll('[data-hr-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
      menu.querySelectorAll('[data-hr-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
    document.querySelectorAll('.hr-header__drop').forEach(function (d) {
      if (d.dataset.hrInit) return; d.dataset.hrInit = '1';
      document.addEventListener('click', function (e) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- halftone zoom (scroll-linked) ---------- */
  var zooms = [];
  function initZoom(root) {
    (root || document).querySelectorAll('[data-hr-zoom]').forEach(function (z) {
      if (z.dataset.hrInit) return; z.dataset.hrInit = '1';
      zooms.push(z);
    });
    if (zooms.length && !window.__hrZoomLoop && !reduce) {
      window.__hrZoomLoop = true;
      var tick = function () {
        zooms.forEach(function (z) {
          var r = z.getBoundingClientRect();
          var total = r.height - window.innerHeight;
          var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
          var max = parseFloat(z.dataset.hrZoom) || 2.6;
          var img = z.querySelector('.hr-zoom__img');
          if (img) img.style.setProperty('--s', (1 + (max - 1) * p * p).toFixed(4));
          var c = z.querySelector('[data-hr-zoom-pct]');
          if (c) c.textContent = Math.round(100 + (max - 1) * 100 * p * p) + '%';
        });
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }

  /* ---------- countdown ---------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-hr-countdown]').forEach(function (c) {
      if (c.dataset.hrInit) return; c.dataset.hrInit = '1';
      var end = new Date(c.dataset.hrCountdown).getTime();
      if (isNaN(end)) { c.hidden = true; return; }
      var f = function (n) { return (n < 10 ? '0' : '') + n; };
      var upd = function () {
        var d = Math.max(0, end - Date.now());
        var s = Math.floor(d / 1000);
        var map = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(map).forEach(function (k) { var el = c.querySelector('[data-' + k + ']'); if (el) el.textContent = f(map[k]); });
        if (d <= 0) clearInterval(iv);
      };
      var iv = setInterval(upd, 1000); upd();
      c.hidden = false;
    });
  }

  /* ---------- product: variant picker ---------- */
  function money(cents, fmt) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, fmt); } catch (e) {}
    }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-hr-product]').forEach(function (p) {
      if (p.dataset.hrInit) return; p.dataset.hrInit = '1';
      var dataEl = p.querySelector('[data-hr-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = p.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = p.querySelector('[data-hr-atc]');
      var btnLabel = btn && btn.querySelector('span');
      var priceEl = p.querySelector('[data-hr-price]');
      var sticky = document.querySelector('[data-hr-sticky-atc]');
      var fieldsets = p.querySelectorAll('[data-hr-option]');
      var labels = { add: btn ? btn.dataset.add : 'Add to bag', sold: btn ? btn.dataset.sold : 'Sold out', na: btn ? btn.dataset.na : 'Unavailable' };

      function selected() {
        var vals = [];
        fieldsets.forEach(function (fs) { var c = fs.querySelector('input:checked'); vals[+fs.dataset.hrOption] = c ? c.value : null; });
        return vals;
      }
      function find(vals) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; }); });
      }
      function update(pushUrl) {
        var vals = selected();
        var v = find(vals);
        fieldsets.forEach(function (fs) {
          var idx = +fs.dataset.hrOption;
          var out = fs.querySelector('[data-hr-opt-val]'); var c = fs.querySelector('input:checked');
          if (out && c) out.textContent = c.value;
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = vals.slice(); test[idx] = inp.value;
            var match = variants.find(function (vv) { return vv.options.every(function (o, i) { return test[i] == null || o === test[i]; }); });
            inp.closest('.hr-chip').classList.toggle('hr-chip--out', !match || !match.available);
          });
        });
        if (!v) { if (btn) { btn.disabled = true; btnLabel.textContent = labels.na; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
        }
        if (btn) { btn.disabled = !v.available; btnLabel.textContent = v.available ? labels.add : labels.sold; }
        if (sticky) {
          var sp = sticky.querySelector('[data-hr-sticky-price]'); if (sp) sp.textContent = money(v.price) + ' — ' + vals.filter(Boolean).join(' / ');
          var sb = sticky.querySelector('button'); if (sb) sb.disabled = !v.available;
        }
        if (pushUrl && window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
        // swap gallery to colour image if a media is tagged with this colour
        p.querySelectorAll('[data-hr-color-media]').forEach(function (m) {
          if (vals.indexOf(m.dataset.hrColorMedia) > -1) m.parentNode.prepend(m);
        });
      }
      p.addEventListener('change', function (e) { if (e.target.matches('[data-hr-option] input')) update(true); });
      update(false);

      // sticky ATC (mobile)
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0]; sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); });
      }

      // gallery dots (mobile)
      var gal = p.querySelector('.hr-gallery'); var dots = p.querySelectorAll('.hr-gallery__dots span');
      if (gal && dots.length) {
        gal.addEventListener('scroll', function () {
          var i = Math.round(gal.scrollLeft / (gal.scrollWidth / dots.length));
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        }, { passive: true });
      }

      // add to bag via ajax → Dawn cart drawer
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || !window.fetch) return; // fall back to normal submit → /cart
          e.preventDefault();
          if (btn) btn.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (btn) btn.removeAttribute('aria-busy');
            if (res.status) { alertMsg(res.description || res.message); return; }
            hrEnsureGift(res).then(function (r2) {
              if (typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(r2 || res); }
              else window.location.href = '/cart';
            });
          }).catch(function () { form.submit(); });
        });
      }
      function alertMsg(m) {
        var el = p.querySelector('[data-hr-error]'); if (el) { el.textContent = m; el.hidden = false; }
      }
    });
  }


  /* ---------- free sticker with every order ---------- */
  var HR_GIFT = window.HR_GIFT || null;
  function hrCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function hrEnsureGift(addRes) {
    if (!HR_GIFT) return Promise.resolve(null);
    return hrCart().then(function (cart) {
      var gift = cart.items.filter(function (i) { return i.variant_id === HR_GIFT; })[0];
      var others = cart.items.filter(function (i) { return i.variant_id !== HR_GIFT; });
      if (others.length && !gift) {
        var fd = new FormData(); fd.append('id', HR_GIFT); fd.append('quantity', 1);
        fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname);
        return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd }).then(function (r) { return r.json(); });
      }
      return null;
    }).catch(function () { return null; });
  }
  window.hrEnsureGift = hrEnsureGift;
  function hrGiftGuard() {
    if (!HR_GIFT) return;
    hrCart().then(function (cart) {
      var gift = cart.items.filter(function (i) { return i.variant_id === HR_GIFT; })[0];
      var others = cart.items.filter(function (i) { return i.variant_id !== HR_GIFT; });
      var q = null;
      if (gift && !others.length) q = 0; else if (gift && gift.quantity > 1) q = 1; else if (!gift && others.length) q = 'add';
      if (q === null) return;
      var req = q === 'add'
        ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: HR_GIFT, quantity: 1 }] }) })
        : fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(HR_GIFT), quantity: q }) });
      req.then(function () { location.reload(); });
    }).catch(function () {});
  }
  if (window.fetch && !window.__hrFetchWrapped) {
    window.__hrFetchWrapped = true;
    var _f = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _f.apply(this, arguments);
      if (/\/cart\/(change|update)/.test(url) && !(init && init.body && String(init.body).indexOf(String(HR_GIFT)) > -1)) p.then(function () { setTimeout(hrGiftGuard, 50); });
      return p;
    };
  }
  document.addEventListener('DOMContentLoaded', function () { if (/\/cart/.test(location.pathname)) hrGiftGuard(); });

  /* ---------- size guide dialog ---------- */
  function initDialogs(root) {
    (root || document).querySelectorAll('[data-hr-open-dialog]').forEach(function (b) {
      if (b.dataset.hrInit) return; b.dataset.hrInit = '1';
      b.addEventListener('click', function () {
        var d = document.getElementById(b.dataset.hrOpenDialog);
        if (d && d.showModal) d.showModal();
      });
    });
    (root || document).querySelectorAll('dialog.hr-dialog').forEach(function (d) {
      if (d.dataset.hrInit) return; d.dataset.hrInit = '1';
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-hr-close-dialog]')) d.close(); });
    });
  }

  /* ---------- collection sort ---------- */
  function initSort(root) {
    (root || document).querySelectorAll('[data-hr-sort]').forEach(function (s) {
      if (s.dataset.hrInit) return; s.dataset.hrInit = '1';
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); });
    });
  }


  /* ---------- cast band arrows (smooth, snap-safe) ---------- */
  function initCast(root) {
    (root || document).querySelectorAll('[data-hr-cast]').forEach(function (t) {
      if (t.dataset.hrInit) return; t.dataset.hrInit = '1';
      var sec = t.closest('section');
      function step() { var it = t.children; return it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : t.clientWidth; }
      function go(dir) {
        var s = step(); var target = Math.max(0, Math.min(t.scrollWidth - t.clientWidth, Math.round(t.scrollLeft / s + dir) * s));
        if (reduce) { t.scrollLeft = target; return; }
        var from = t.scrollLeft, t0 = performance.now(), dur = 700; t.style.scrollSnapType = 'none';
        (function f(now) { var k = Math.min(1, (now - t0) / dur); var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; t.scrollLeft = from + (target - from) * e; if (k < 1) requestAnimationFrame(f); else t.style.scrollSnapType = ''; })(t0);
      }
      var p = sec && sec.querySelector('[data-hr-cast-prev]'), n = sec && sec.querySelector('[data-hr-cast-next]');
      if (p) p.addEventListener('click', function () { go(-1); });
      if (n) n.addEventListener('click', function () { go(1); });
    });
  }

  function initAll(root) {
    initReveals(root); initTickers(root); initHeader(); initZoom(root); initCountdowns(root);
    initProduct(root); initDialogs(root); initSort(root); initCast(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
